/**
 * Texto plano a partir del HTML que guarda el admin: resuelve las entidades
 * (`&amp;`, `&aacute;`, `&#39;`…) y quita las etiquetas. Los saltos de `<br>` y
 * de fin de párrafo se conservan como `\n`.
 */
export function htmlToText(value: string | null | undefined): string {
  if (!value) return ''

  const html = value.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n')

  return (new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '').trim()
}
